import React from "react";

const InstaBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3329_131547)">
      <path
        d="M1.99961 2.17735C-0.515052 4.78935 -0.000385359 7.56402 -0.000385359 15.9934C-0.000385359 22.9934 -1.22172 30.0107 5.17028 31.6627C7.16628 32.176 24.8516 32.176 26.8449 31.66C29.5063 30.9734 31.6716 28.8147 31.9676 25.0507C32.0089 24.5254 32.0089 7.47069 31.9663 6.93469C31.6516 2.92535 29.1836 0.614688 25.9316 0.146688C25.1863 0.0386878 25.0369 0.00668784 21.2129 2.11708e-05C7.64895 0.00668784 4.67561 -0.597312 1.99961 2.17735Z"
        fill="url(#paint0_linear_3329_131547)"
      />
      <path
        d="M15.9977 4.18535C11.1564 4.18535 6.55907 3.75469 4.80307 8.26135C4.07774 10.1227 4.18307 12.54 4.18307 16.0014C4.18307 19.0387 4.08574 21.8934 4.80307 23.74C6.55507 28.2494 11.1897 27.8174 15.9951 27.8174C20.6311 27.8174 25.4111 28.3 27.1884 23.74C27.9151 21.86 27.8084 19.4787 27.8084 16.0014C27.8084 11.3854 28.0631 8.40535 25.8244 6.16802C23.5577 3.90135 20.4924 4.18535 15.9924 4.18535H15.9977ZM14.9391 6.31469C25.0377 6.29869 26.3231 5.17602 25.6137 20.772C25.3617 26.288 21.1617 25.6827 15.9991 25.6827C6.58574 25.6827 6.31507 25.4134 6.31507 15.996C6.31507 6.46935 7.06174 6.32002 14.9391 6.31202V6.31469ZM22.3044 8.27602C21.5217 8.27602 20.8871 8.91069 20.8871 9.69335C20.8871 10.476 21.5217 11.1107 22.3044 11.1107C23.0871 11.1107 23.7217 10.476 23.7217 9.69335C23.7217 8.91069 23.0871 8.27602 22.3044 8.27602ZM15.9977 9.93335C12.6471 9.93335 9.93107 12.6507 9.93107 16.0014C9.93107 19.352 12.6471 22.068 15.9977 22.068C19.3484 22.068 22.0631 19.352 22.0631 16.0014C22.0631 12.6507 19.3484 9.93335 15.9977 9.93335ZM15.9977 12.0627C21.2044 12.0627 21.2111 19.94 15.9977 19.94C10.7924 19.94 10.7844 12.0627 15.9977 12.0627Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3329_131547"
        x1="4.60607"
        y1="4.64959"
        x2="27.3031"
        y2="27.3422"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAE100" />
        <stop offset="0.15" stop-color="#FCB720" />
        <stop offset="0.3" stop-color="#FF7950" />
        <stop offset="0.5" stop-color="#FF1C74" />
        <stop offset="1" stop-color="#6C1CD1" />
      </linearGradient>
      <clipPath id="clip0_3329_131547">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default InstaBrand1;
